export default function (to, from, savedPosition) {
	return savedPosition || { x: 0, y: 0 };
}
